import { ObjectMap } from '@mewa/types';

export type CollectionProducts<T> = {
  name: string | null;
  slug: string | null;
  claim: string | null;
  emotionAssetId: string | null;
  products: T[];
};

type ProductWithCollection = {
  collection: {
    id: string;
    name: string;
    claim: string;
    slug: string;
    assets: {
      emotion: string | null;
    };
  } | null;
};

export const groupByCollection = <T extends ProductWithCollection>(
  products: T[],
): CollectionProducts<T>[] => {
  const grouped = products.reduce<ObjectMap<CollectionProducts<T>>>(
    (productsGroupedByCollection, product) => {
      const collectionId = product.collection?.id ?? 'ohne Kollektion';

      if (!productsGroupedByCollection[collectionId]) {
        productsGroupedByCollection[collectionId] = {
          name: product.collection?.name ?? null,
          claim: product.collection?.claim ?? null,
          slug: product.collection?.slug ?? null,
          products: [],
          emotionAssetId: product.collection?.assets?.emotion ?? null,
        };
      }

      productsGroupedByCollection[collectionId].products.push(product);

      return productsGroupedByCollection;
    },
    {},
  );

  return Object.values(grouped);
};
